import { useLocation } from 'react-router-dom';
import { AuthenticatedPaths } from '../constants/Paths';

export default function useIsAuthenticatedRoute() {
    const { pathname } = useLocation();

    const authenticatedPath = Object.values(AuthenticatedPaths).some((path) => {
        return pathname.startsWith(path);
    });

    return authenticatedPath;
}
